import React from 'react';
import { Activity, ChevronRight } from 'lucide-react';

function MonitoringEmptyHint({
  hint,
  onViewRecord,
  subtitle,
  className = '',
}) {
  if (!hint) {
    return (
      <div className={`mt-3 ${className}`}>
        {subtitle && <p className="text-sm text-[#5b6780]">{subtitle}</p>}
        <p className="text-xs text-[#76829a] mt-2 leading-relaxed">
          No alerts in the system yet. Check Timeline to confirm collection runs are active.
        </p>
      </div>
    );
  }

  return (
    <div className={`mt-3 text-left max-w-md mx-auto ${className}`}>
      {subtitle && <p className="text-sm text-[#5b6780] text-center">{subtitle}</p>}
      <p className="text-sm font-medium text-[#45516a] text-center mt-1">
        {hint.message}
      </p>
      <p className="text-xs text-[#76829a] mt-1.5 text-center line-clamp-2">
        {hint.headline}
        <span className="text-[#76829a] mx-1">·</span>
        {hint.dateLabel}
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-4">
        {onViewRecord && (
          <button
            type="button"
            onClick={() => onViewRecord(hint.record)}
            className="inline-flex items-center gap-1 text-[13px] font-medium text-[#1c4ed8] hover:text-[#1c4ed8] px-3 rounded-md hover:bg-[#e7edfc] transition h-8"
          >
            View last alert <ChevronRight size={12} />
          </button>
        )}
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full">
          <Activity size={11} className="text-emerald-600" />
          Monitoring active
        </span>
      </div>
    </div>
  );
}

export default MonitoringEmptyHint;